import { render, staticRenderFns } from "./commandSidebarAddNewSupplier.vue?vue&type=template&id=fa8cbb42&"
import script from "./commandSidebarAddNewSupplier.vue?vue&type=script&lang=js&"
export * from "./commandSidebarAddNewSupplier.vue?vue&type=script&lang=js&"
import style0 from "./commandSidebarAddNewSupplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports